import React from 'react';

import { Box, IconButton } from '@mui/material';
import clsx from 'clsx';

import { ReactComponent as DeleteIcon } from 'assets/icons/DeleteIcon.svg';

import { IRemoveButtonProps } from './types';

import styles from './RemoveButton.module.scss';

export const RemoveButton: React.FC<IRemoveButtonProps> = ({
  canRemove,
  notRequired = true,
  buttonStyles,
  disabled,
  children,
  containerStyles,
  ...props
}) => {
  return (
    <Box className={clsx(styles.removeButtonContainer, containerStyles)}>
      {(canRemove || notRequired) && (
        <IconButton {...props} className={clsx(buttonStyles, styles.buttonWrapper)} disabled={disabled}>
          <DeleteIcon />
          {children &&<Box className={styles.buttonText} component="span">{children}</Box>}
        </IconButton>
      )}
    </Box>
  );
};
